/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionspagedescription2Inputs */

const en_actionspagedescription2 = /** @type {(inputs: Actionspagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a short action: your favourites get it as a push, and it shows on your place page and in the feed.`)
};

const de_actionspagedescription2 = /** @type {(inputs: Actionspagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schalte eine kurze Aktion: Deine Favoriten bekommen sie als Mitteilung, und sie steht auf deiner Ortsseite und im Feed.`)
};

/**
* | output |
* | --- |
* | "Send a short action: your favourites get it as a push, and it shows on your place page and in the feed." |
*
* @param {Actionspagedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionspagedescription2 = /** @type {((inputs?: Actionspagedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionspagedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionspagedescription2(inputs)
	return de_actionspagedescription2(inputs)
});
export { actionspagedescription2 as "actionsPageDescription" }